import { render } from "./HouseTable.vue?vue&type=template&id=36aafe02"
import script from "./HouseTable.vue?vue&type=script&lang=js"
export * from "./HouseTable.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__